import { useCallback } from "react";
import useRouteName from "../hooks/useRouteName.js";
import { clientFetch } from "@flights/client-fetch";
import reportError from "../utils/report-error.js";
import Debug from "debug";
import * as watchClientMetrics from "./watchClientMetrics.js";
const debug = Debug("useClientMetrics");
const useClientMetrics = () => {
    const route = useRouteName();
    const track = useCallback((name, value) => {
        watchClientMetrics.log(name, value);
        buffer.push({ name, route, value });
    }, [route]);
    const onRender = useCallback((id, phase, actualDuration) => {
        const name = `${id}_${phase}`;
        phase === "mount" && track(name, actualDuration);
    }, [track]);
    const trackParameterizedClientMetric = useCallback((name, parameters) => {
        const metric = { template: name, parameters, route };
        buffer.push(metric);
    }, [route]);
    return {
        trackClientMetric: track,
        trackParameterizedClientMetric,
        trackRenderTime: onRender
    };
};
const buffer = [];
const REPORT_INTERVAL = 10 * 1000;
const initClientMetrics = () => {
    setInterval(reportClientMetrics, REPORT_INTERVAL);
};
const reportClientMetrics = () => {
    if (buffer.length > 0) {
        const metricsToReport = buffer.splice(0);
        debug("Reported metrics", metricsToReport);
        const canTrack = !window?.__GLOBAL_CONTEXT__?.shouldNotTrack || window?.__GLOBAL_CONTEXT__?.userAgent.isWebview;
        if (!canTrack) {
            return;
        }
        clientFetch("/track/client-metrics", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            credentials: "include",
            referrerPolicy: "strict-origin-when-cross-origin",
            body: JSON.stringify({
                metrics: metricsToReport
            })
        }).catch((error) => {
            debug("Failed to report", metricsToReport, "with error", error);
            buffer.unshift(...metricsToReport);
            if (error.name !== "ClientFetchNotAuthorizedError") {
                reportError(new Error(`Failed to report client metrics from client side. ${error.message}`));
            }
        });
    }
};
export default useClientMetrics;
export { initClientMetrics };
